exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ticket-remark-content-summary[data-v-67815d80] {\n  color: #3a6484;\n}\n._1[data-v-67815d80] {\n  border-left: 3px solid #f5f6fb;\n  min-height: calc(100vh - 61px);\n  padding: 20px;\n}\n._gray[data-v-67815d80] {\n  color: DarkGray;\n}\n._2[data-v-67815d80] {\n  padding:10px 0;\n  border-bottom:1px solid Gainsboro;\n}\n._2[data-v-67815d80]:hover {\n  -webkit-box-shadow: 1px 1px 20px 2px #e6e9da;\n          box-shadow: 1px 1px 20px 2px #e6e9da;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67815d80","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/RecentTicketEvent.vue
// module id = 1017
// module chunks = 75